module.exports = __webpack_public_path__ + "img/market-dark.65c5db76.svg";